import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=0a0f8fcc&scoped=true&"
import script from "./ModelList.vue?vue&type=script&lang=js&"
export * from "./ModelList.vue?vue&type=script&lang=js&"
import style0 from "./ModelList.vue?vue&type=style&index=0&id=0a0f8fcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f8fcc",
  null
  
)

export default component.exports